import { render, staticRenderFns } from "./2-1.CreateDetail.vue?vue&type=template&id=2b23e889&scoped=true"
import script from "./2-1.CreateDetail.vue?vue&type=script&lang=js"
export * from "./2-1.CreateDetail.vue?vue&type=script&lang=js"
import style0 from "./2-1.CreateDetail.vue?vue&type=style&index=0&id=2b23e889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23e889",
  null
  
)

export default component.exports